import { System } from './../../../shared-components/System';
import {Component, OnInit, Inject} from '@angular/core';
import { Announcement } from '../announcement.model';
import { UserService } from '../../../shared-components/user/user.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

// Class
@Component ({
    selector: 'announcementMessage',
    templateUrl: './announcement-message.component.html'
})
export class AnnouncementMessageComponent implements OnInit {

    // Properties
    districtMessages: Announcement[];
    dialogBox: MatDialogRef<AnnouncementMessageComponent>;  // The dialog this is stored in
    stripHTML: (str: string) => string;
    junkDate = new Date('0001-01-01T00:00:00');

    // Class Functions
    constructor (
        private userService: UserService,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {}

    // Event Functions
    ngOnInit () {
        // POST: captures district announcements to display
        this.stripHTML = System.stripHTML;
        this.districtMessages = this.data.districtMessages;
    }
}
